module.exports = __webpack_public_path__ + "img/preferably.e193e604.png";